import { useEffect } from 'react';
import { startPlantArrivalWatch, stopPlantArrivalWatch } from './plantArrivalWatch';

/**
 * Keeps the catalogue watch running for as long as the app is open (SPEC-016).
 *
 * Renders nothing, and exists only so the watch has somewhere always-mounted to
 * live — the counterpart of `useAutomaticAppUpdate`, and mounted beside it above
 * the routes so a navigation cannot restart it.
 *
 * It never asks for permission. The watch records what it read whatever the
 * permission is and announces only when it is already `granted`, so app start
 * cannot prompt someone who has not opted in.
 */
export function usePlantArrivalNotifications({ localeCode = '', languageCode = 'en' } = {}) {
    useEffect(() => {
        startPlantArrivalWatch({ localeCode, languageCode });

        return stopPlantArrivalWatch;
    }, [languageCode, localeCode]);
}
